module.exports = __webpack_public_path__ + "img/magistech_logo_branca.7f2ae305.png";